interface Props {
  size?: 'sm' | 'md' | 'lg'
}

const SIZES = { sm: 16, md: 24, lg: 32 }

export function LoadingSpinner({ size = 'md' }: Props) {
  const s = SIZES[size]
  return (
    <div className="flex items-center justify-center p-8">
      <svg
        width={s}
        height={s}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="animate-spin"
        style={{ color: 'var(--primary)' }}
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
    </div>
  )
}
